import React, {Component} from 'react';
import { Col, Row, Typography, Button, Spin } from 'antd';
import Box from '../../components/utility/box';
import { DvIntlMessages,DvNotification } from '../../components/utility/dvGeneralUtilities';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { getIcmdAuthStatus, initializeIcmdAuth } from '../../redux/auth/authServices';

let isIcmdConfigurationMounted;

class IcmdConfiguration extends Component {
  state = {
    isAuthorizationProcessActive: false,
    authorizationProcessStatus: undefined,
    isAppAuthorized: undefined,
    configuredEmail:'...'
  }

  componentDidMount() {
    isIcmdConfigurationMounted = true;
    getIcmdAuthStatus().then(response => {
      if (response.status && response.authStatus) {
        if (response.authStatus.status === "ready") this.setState({ isAppAuthorized: true, configuredEmail:response.authStatus.email });
        else this.setState({ isAppAuthorized: false, configuredEmail:response.authStatus.email });
      } else {
        this.setState({ isAppAuthorized: false, configuredEmail: "N/A" });
      }
      
    }).catch(() => {
      DvNotification({type:'error',});
      this.setState({ isAppAuthorized: false, configuredEmail: "N/A" });
    });
  }

  componentWillUnmount() {
    isIcmdConfigurationMounted = false;
  }

  styleKeyColumn = { textAlign: 'left', flex: '0 1 200px', marginTop: 2, marginLeft: 10 };
  styleValueColumn = { fontWeight: 'bold' };

  authorizeApplication = () => {
    this.setState({
      isAuthorizationProcessActive: true,
      authorizationProcessStatus: 'Initializing authorization... ',
      isAppAuthorized: undefined
    }, () => {
      // Delete existing files from zoho folder and clear corresponding redis entries. Get authorization url.
      initializeIcmdAuth().then(async (authorizationUrlResponse) => {
        if (!authorizationUrlResponse.status || !authorizationUrlResponse.authInfo || !authorizationUrlResponse.authInfo.authUrl) throw new Error('Error in initializing the authorization process.');
        window.open(authorizationUrlResponse.authInfo.authUrl);
        for (let i = 120; i >= 0; i--) { // Wait 120 seconds for application authorization process to complete
          this.setState({ authorizationProcessStatus: 'Authorizing application... ' + i + 's' });
          await new Promise(resolve => setTimeout(resolve, 1000));
          if (!isIcmdConfigurationMounted) return;
          if (this.state.isAuthorizationProcessActive === false) {
            return;
          }
          getIcmdAuthStatus().then(response => {
            if (response.status && response.authStatus && response.authStatus.status === "ready") {
                this.setState({ 
                  isAppAuthorized: true, 
                  authorizationProcessStatus: 'Authorization success',
                  isAuthorizationProcessActive:false
                });
            } else if (response.status && response.authStatus && response.authStatus.status === "rejected") {
              this.setState({ 
                isAppAuthorized: false, 
                authorizationProcessStatus: 'Authorization rejected',
                isAuthorizationProcessActive:false
              });
            } else if (response.status && response.authStatus && response.authStatus.status === "error") {
              this.setState({ 
                isAppAuthorized: false, 
                authorizationProcessStatus: 'Authorization error',
                isAuthorizationProcessActive:false
              });
            }
            else this.setState({ isAppAuthorized: false });
          });
        }

        if (this.state.isAppAuthorized !== true) {
          this.setState({
            isAppAuthorized: false, 
            authorizationProcessStatus: 'Authorization failed',
            isAuthorizationProcessActive:false
          });
        }
      });
    });
  }

  render() {
    return <>
      <Typography.Title level={3}>{DvIntlMessages('general.icmdMeaning') + ' (' + DvIntlMessages('general.icmd') + ')'}</Typography.Title>
      <Box>
        <Row style={{ fontSize: 20, fontWeight: 500 }}>{DvIntlMessages('settings.zohoEmail.title')}</Row>
        <Row type='flex' align='middle' style={{ marginTop: 6 }}>
          <Col style={this.styleKeyColumn}>{DvIntlMessages('settings.zohoEmail.emailAccount')}:</Col>
          <Col style={this.styleValueColumn}>{this.state.configuredEmail}</Col>
        </Row>
        <Row type='flex' align='middle' style={{ marginTop: 6 }}>
          <Col style={this.styleKeyColumn}>{DvIntlMessages('settings.zohoEmail.appAuthorization')}:</Col>
          <Col style={this.styleValueColumn}>
            <Spin spinning={this.state.isAppAuthorized === undefined}>
              {this.state.isAppAuthorized !== undefined &&
                (this.state.isAppAuthorized ? <CheckOutlined style={{ color: 'green' }} /> : <CloseOutlined style={{ color: 'red' }} />)
              }
            </Spin>
          </Col>
        </Row>
        <Row style={{ marginTop: 16 }}>
          <Col style={{ marginRight: 10 }}>
            <Button type='primary' onClick={() => this.authorizeApplication()} loading={this.state.isAuthorizationProcessActive} disabled={this.state.isAuthorizationProcessActive}>
              {DvIntlMessages('settings.zohoEmail.authorizeApplication')}
            </Button>
          </Col>
          <Col style={{ display: 'flex', alignItems: 'center' }}>
            {this.state.authorizationProcessStatus}
          </Col>
        </Row>
        {this.state.isAuthorizationProcessActive &&
          <Row style={{ marginTop: 4, color: 'red' }}>
            {DvIntlMessages('settings.zohoEmail.authorizeApplicationMessage')}
          </Row>
        }
      </Box>
    </>;
  }
}

export { IcmdConfiguration as default };
